// Credit columns whose values can be displayed as credits, minutes or hours via the
// VCC unit toggle. The backend exposes, for each base field, a "<field>_in_minutes" and
// "<field>_in_hours" companion that already carries the value formatted for that unit
// (e.g. "30 min", "0h30"), so the on-screen cell and the exported report always match.
// Columns natively tracked in hours (Private Class Hours) are intentionally NOT here.
export const CREDIT_BASE_FIELDS = [
  'tutoring_credits_used',
  'tutoring_credits_available',
  'purchased_tutoring_credits_available',
  'membership_tutoring_credits_available',
];

const UNIT_SUFFIX = {
  credits: '',
  minutes: '_in_minutes',
  hours: '_in_hours',
};

export const CREDITS_UNIT_OPTIONS = [
  { value: 'credits', label: 'Credits' },
  { value: 'minutes', label: 'Minutes' },
  { value: 'hours', label: 'Hours' },
];

export function isCreditBaseField(field) {
  return CREDIT_BASE_FIELDS.includes(field);
}

// Given a base credit field and the selected unit, return the field that holds the value
// in that unit. For "credits" (or an unknown unit) it returns the base field unchanged.
export function creditsFieldFor(baseField, unit) {
  const suffix = UNIT_SUFFIX[unit] || '';
  return `${baseField}${suffix}`;
}
